export class GlobalConstants {
    /** @deprecated Use AppConfigService.appName instead */
    public static readonly ProjectName: string = 'FlipeOn';
}